export default {"src":"/_next/static/media/icon-velocity.6f753b25.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};